import React from 'react';
// import globalStyles from './globalStyles';
import useGlobalStyles from './globalStyles';

interface IbmPlexMonoTextProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'style'> {
	style?: React.CSSProperties | React.CSSProperties[];
	weight?: 'regular' | 'bold' | 'medium' | 'italic';
}

const IbmPlexMonoText: React.FC<IbmPlexMonoTextProps> = ({ style, weight = 'regular', ...rest }) => {
	let customStyle: React.CSSProperties;
	const globalStyles = useGlobalStyles();
	
	switch (weight) {
		case 'bold':
			customStyle = globalStyles.ibmPlexMonoBold;
			break;
		case 'medium':
			customStyle = globalStyles.ibmPlexMonoMedium;
			break;
		case 'italic':
			customStyle = globalStyles.ibmPlexMonoItalic;
			break;
		default:
			customStyle = globalStyles.ibmPlexMonoRegular;
			break;
	}

	return (
		<div style={{ ...customStyle, ...(Array.isArray(style) ? Object.assign({}, ...style) : style) }} {...rest} />
	)
};

export default IbmPlexMonoText;
